<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p>服务实例列表</p>
    </div>
    <div class="main-body">
      <el-form :inline="true">
        <el-form-item label="运行环境">
          <el-select
            clearable
            filterable
            @change="handleEnvChange"
            v-model="env"
            placeholder="请选择运行环境"
          >
            <el-option
              v-for="item in pickerAll.env"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择服务">
          <el-select
            filterable
            clearable
            @change="handleServiceChange"
            v-model="taskId"
            placeholder="请选择服务"
          >
            <el-option
              v-for="item in serviceListAll"
              :key="item.id"
              :label="item.label || item.typeDesc + '-' + item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="w100" type="primary" @click="queryRecordList"
            >查询</el-button
          >
          <el-button class="w100" type="primary" @click="handleAdd"
            >添加服务实例</el-button
          >
          <el-button
            v-if="!uploadDocker"
            class="w100"
            :type="publish ? 'info' : 'success'"
            @click="handleBeforePublish()"
            >{{ publish ? "取消发布" : "发布" }}</el-button
          >
          <el-button
            v-if="!publish"
            class="w150"
            :type="uploadDocker ? 'info' : 'success'"
            @click="handleBeforeUploadDockerImage()"
            >{{ uploadDocker ? "取消上传" : "上传dockr镜像" }}</el-button
          >
          <el-button
            class="w100"
            type="success"
            @click="handleSelectPackage()"
            v-if="publish || uploadDocker"
            >选择package</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="recordList"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        v-loading="tableLoading"
        :element-loading-text="tableLoadingText"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="publish || uploadDocker"
        ></el-table-column>
        <el-table-column property="taskId" label="服务名称">
          <template slot-scope="scope">{{
            getPickerItemDesc(scope.row.taskId, serviceList, "id", "name")
          }}</template>
        </el-table-column>
        <el-table-column property="serverId" label="服务器名称">
          <template slot-scope="scope">{{
            getPickerItemDesc(
              scope.row.serverId,
              serverList,
              "id",
              "serverName"
            )
          }}</template>
        </el-table-column>
        <el-table-column
          property="environmentDesc"
          label="运行环境"
        ></el-table-column>
        <el-table-column
          property="vmArguments"
          label="虚拟机参数"
        ></el-table-column>
        <el-table-column
          property="schedulingStatusDesc"
          label="调度状态"
        ></el-table-column>
        <el-table-column
          property="publishPath"
          label="部署路径"
        ></el-table-column>
        <el-table-column
          property="listenPort"
          label="监听端口"
        ></el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
        <el-table-column label="运行状态">
          <template slot-scope="scope">
            {{
              scope.row.statusDesc +
                (scope.row.progressCount
                  ? "(" + scope.row.progressCount + "个进程)"
                  : "")
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400px">
          <template slot-scope="scope">
            <el-button
              v-if="
                (scope.row.packagingType == '0' ||
                  scope.row.packagingType == '1') &&
                  (scope.row.status == 'PAUSED' || scope.row.status == 'NORMAL')
              "
              class="w75"
              @click.native.prevent="handleOperate(scope.row)"
              :type="scope.row.status == 'PAUSED' ? 'success' : 'danger'"
              size="small"
              >{{ scope.row.status == "PAUSED" ? "运行" : "停止" }}</el-button
            >
            <el-button
              class="w75"
              @click.native.prevent="handleViewReleaseVersion(scope.row)"
              type="primary"
              size="small"
              >发布记录</el-button
            >
            <el-button
              class="w75"
              @click.native.prevent="handleEdit(scope.row)"
              type="primary"
              size="small"
              >编辑</el-button
            >
            <el-button
              class="w75"
              @click.native.prevent="handleDelete(scope.row.id)"
              type="info"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="handlePageChange"
          background
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="(editRecord.id ? '编辑' : '添加') + '服务实例'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="editRecord" label-width="100px">
        <el-form-item label="选择服务">
          <el-select
            filterable
            clearable
            v-model="editRecord.taskId"
            placeholder="请选择服务"
          >
            <el-option
              v-for="item in serviceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否监控">
          <el-switch v-model="editRecord.monitoring"></el-switch>
        </el-form-item>
        <el-form-item label="选择服务器">
          <el-select
            filterable
            clearable
            v-model="editRecord.serverId"
            placeholder="请选择服务器"
          >
            <el-option
              v-for="item in serverList"
              :key="item.id"
              :label="item.serverName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运行环境">
          <el-select
            clearable
            filterable
            v-model="editRecord.environment"
            placeholder="请选择运行环境"
          >
            <el-option
              v-for="item in picker.env"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="虚拟机参数">
          <el-input
            v-model="editRecord.vmArguments"
            placeholder="请输入虚拟机参数"
          ></el-input>
        </el-form-item>
        <el-form-item label="部署路径">
          <el-input
            v-model="editRecord.publishPath"
            placeholder="请输入部署路径"
          ></el-input>
        </el-form-item>
        <el-form-item label="监听端口号">
          <el-input
            v-model="editRecord.listenPort"
            placeholder="请输入监听端口号"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="editRecord.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="w75" @click="dialogVisible = false">取 消</el-button>
        <el-button class="w75" type="primary" @click="handleCommit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="publish ? '发布' : uploadDocker ? '上传docker镜像' : ''"
      :visible.sync="publishDialogVisible"
      width="1200px"
    >
      <el-table
        :data="availablePackageList"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="系统正在发布，请稍候..."
        element-loading-spinner="el-icon-loading"
        height="500px"
      >
        <el-table-column property="status" label="发布状态">
          <template slot-scope="scope">{{
            getPickerItemDesc(
              scope.row.status,
              picker.releaseStatus,
              "value",
              "label"
            )
          }}</template>
        </el-table-column>
        <el-table-column
          property="userAccountNo"
          label="用户编号"
        ></el-table-column>
        <el-table-column
          property="commitVersion"
          label="提交版本"
        ></el-table-column>
        <el-table-column label="打包类型">
          <template slot-scope="scope">{{
            getPickerItemDesc(
              scope.row.packagingType,
              picker.packageType,
              "value",
              "label"
            )
          }}</template>
        </el-table-column>
        <el-table-column
          property="branchName"
          label="分支名称"
        ></el-table-column>
        <el-table-column property="comment" label="申请说明"></el-table-column>
        <el-table-column
          property="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          property="moduleName"
          label="模块名称"
        ></el-table-column>
        <el-table-column
          property="packageUserAccountNo"
          label="打包用户编号"
        ></el-table-column>
        <el-table-column
          property="packageTime"
          label="打包时间"
        ></el-table-column>
        <el-table-column width="100px" label="操作">
          <template slot-scope="scope">
            <el-button
              class="w75"
              @click.native.prevent="handleConfirm(scope.row.id)"
              type="primary"
              size="small"
              >{{ publish ? "确认发布" : "确认上传" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="发布版本记录"
      :visible.sync="releaseVersionDialogVisible"
      width="1000px"
    >
      <el-table
        :data="releaseVersionList"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据获取中，请稍候..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          property="releaseVersion"
          label="发布版本"
        ></el-table-column>
        <el-table-column
          property="publishTime"
          label="发布时间"
        ></el-table-column>
        <el-table-column property="statusDesc" label="状态"></el-table-column>
        <el-table-column
          property="applicantPhone"
          label="申请人手机号"
        ></el-table-column>
      </el-table>
      <div style="padding: 10px;">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="releaseVersionTotal"
          :page-size="releaseVersionPageSize"
          @current-change="handleReleaseVersionPageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "serverInstanceList",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      editRecord: {},
      loading: false,
      tableLoading: false,
      tableLoadingText: "数据获取中...",
      dialogVisible: false,
      publishDialogVisible: false,
      releaseVersionDialogVisible: false,
      picker: {
        env: [],
      },
      pickerAll: {
        env: [],
      },
      env: "",
      taskId: "",
      serverList: [],
      serviceList: [],
      serviceListAll: [],
      selectedInstance: [],
      publish: false,
      availablePackageList: [],
      releaseVersionList: [],
      currentId: "",
      releaseVersionbeginIndex: 0,
      releaseVersionPageSize: 10,
      releaseVersionTotal: 0,
      beginIndex: 0,
      pageSize: 5,
      total: 0,
      uploadDocker: false,
    };
  },
  mounted() {
    let self = this;
    Utils.getPicker([
      {
        type: "4",
        name: "env",
      },
      {
        type: "2",
        name: "packageType",
      },
      {
        type: "1",
        name: "releaseStatus",
      },
    ]).then((result) => {
      self.picker = result.picker;
      self.pickerAll = result.pickerAll;
    });
    let queryData = this.$route.query;
    if (queryData.taskId) {
      this.env = queryData.env || "";
      this.taskId = queryData.taskId;
      this.publish = queryData.opt == '1';
      this.uploadDocker = queryData.opt == '2';
    }
    this.getServerList();
    this.getServiceList();
    this.queryRecordList();
  },
  methods: {
    handlePageChange(pageNum) {
      this.beginIndex = (pageNum - 1) * this.pageSize;
      this.queryRecordList();
    },

    handleViewReleaseVersion(row) {
      this.currentId = row.id;
      this.releaseVersionDialogVisible = true;
      this.releaseVersionbeginIndex = 0;
      this.getReleaseVersionList({
        sourceAppType: 1,
        taskInstanceId: this.currentId,
        beginIndex: this.releaseVersionbeginIndex,
        pageSize: this.releaseVersionPageSize,
      });
    },

    handleReleaseVersionPageChange(val) {
      this.releaseVersionbeginIndex =
        parseInt(val - 1) * this.releaseVersionPageSize;
      this.getReleaseVersionList({
        sourceAppType: 1,
        taskInstanceId: this.currentId,
        beginIndex: this.releaseVersionbeginIndex,
        pageSize: this.releaseVersionPageSize,
      });
    },

    getReleaseVersionList(param) {
      let self = this;
      self.loading = true;
      self.loading = "数据获取中，请稍候...";
      this.$http
        .get("/release/listReleaseVersion?" + this.$qs.stringify(param), {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.releaseVersionList = res.ldata;
          self.releaseVersionTotal = res.mdata.total;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleOperate(row) {
      this.$confirm(
        "是否确认" + (row.status == "PAUSED" ? "运行" : "停止") + "？"
      ).then(() => {
        this.oprate({
          taskInstanceId: row.id,
          operateType: row.status == "PAUSED" ? "0" : "1",
        });
      });
    },

    oprate(param) {
      let self = this;
      this.tableLoading = true;
      this.tableLoadingText = "系统正在处理，请稍候...";
      let timeout = setTimeout(() => {
        self.tableLoading = false;
        self.showErrorMessage("请求超时");
      }, 60000);
      this.$http
        .post("/schedule/taskInstance/operate", this.$qs.stringify(param), {
          headers: {
            token: this.token,
          },
        })
        .then(function(response) {
          clearTimeout(timeout);
          self.tableLoading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.publishDialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          clearTimeout(timeout);
          self.tableLoading = false;
        });
    },

    handleEnvChange(val) {
      if (this.publish) {
        this.queryRecordList();
      }
    },

    handleServiceChange(val) {
      if (this.publish) {
        this.queryRecordList();
      }
    },

    getPickerItemDesc(value, picker, valueKey, labelKey) {
      let index = picker.findIndex((element) => element[valueKey] == value);
      return index > -1 ? picker[index][labelKey] : "";
    },

    handleAdd() {
      this.editRecord = { monitoring: false };
      this.dialogVisible = true;
    },

    handleSelectionChange(val) {
      let selectedInstance = [];
      let self = this;
      val.forEach((element) => selectedInstance.push(element.id));
      this.selectedInstance = selectedInstance;
    },

    handleBeforePublish() {
      if (!this.validBefortOperate()) {
        return;
      }
      this.publish = !this.publish;
    },

    handleBeforeUploadDockerImage() {
      if (!this.validBefortOperate()) {
        return;
      }
      this.uploadDocker = !this.uploadDocker;
    },

    validBefortOperate() {
      if (!this.publish) {
        // if (!this.env && this.publish) {
        //   this.$message({
        //     type: "warning",
        //     message: "请指定运行环境",
        //     center: true,
        //   });
        //   return false;
        // }
        if (!this.taskId) {
          this.$message({
            type: "warning",
            message: "请指定服务",
            center: true,
          });
          return false;
        }
        this.queryRecordList();
        this.$message({
          type: "info",
          message: "请选择服务实例",
          center: true,
        });
      }
      return true;
    },

    handleSelectPackage(row) {
      // if (!this.env && this.publish) {
      //   this.$message({
      //     type: "warning",
      //     message: "请指定运行环境",
      //     center: true,
      //   });
      //   return;
      // }
      if (!this.taskId) {
        this.$message({
          type: "warning",
          message: "请指定服务",
          center: true,
        });
        return;
      }
      if (this.selectedInstance.length == 0) {
        this.$message({
          type: "warning",
          message: "请选择服务实例",
          center: true,
        });
        return;
      }
      this.getAvailablePackage();
      this.publishDialogVisible = true;
    },

    handleConfirm(id) {
      let param = {
        instanceList: this.selectedInstance.join(","),
        applyId: id,
      };

      this.$confirm("是否确认"+ (this.publish ? '发布' : (this.uploadDocker ? '上传' : '')) +"？").then(() => {
        this.commit(param);
      });
    },

    commit(param) {
      let self = this;
      this.loading = true;
      let timeout = setTimeout(() => {
        self.loading = false;
        self.showErrorMessage("请求超时");
      }, 120000);
      let url = this.publish ? '/publish/doPublish' : (this.uploadDocker ? '/publish/uploadDockerImage' : '');
      this.$http
        .post(url, this.$qs.stringify(param), {
          headers: {
            token: this.token,
          },
        })
        .then(function(response) {
          clearTimeout(timeout);
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.publishDialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          clearTimeout(timeout);
          self.loading = false;
        });
    },

    handleEdit(row) {
      this.editRecord = JSON.parse(JSON.stringify(row));
      // 将后端返回的 0/1 转换为布尔值
      this.editRecord.monitoring = this.editRecord.monitoring === 1;
      this.dialogVisible = true;
    },

    handleCommit() {
      // 将布尔值转换为 0/1 提交到后端
      const params = { ...this.editRecord };
      if (typeof params.monitoring === 'boolean') {
        params.monitoring = params.monitoring ? 1 : 0;
      }
      this.createOrUpdate(params);
    },

    createOrUpdate(params) {
      let self = this;
      this.$http
        .post(
          "/admin/release/task/instance/createOrUpdate",
          this.$qs.stringify(params),
          {
            headers: {
              token: this.token,
            },
          }
        )
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.dialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          console.log(response);
        });
    },

    handleDelete(id) {
      this.$confirm("是否确认删除？").then(() => {
        this.delete(id);
      });
    },

    delete(id) {
      let self = this;
      self.loading = true;
      this.$http
        .get("/admin/release/task/instance/delete?id=" + id, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = true;
        });
    },

    getServerList() {
      let self = this;
      self.loading = true;
      this.$http
        .get("/admin/release/server/list", {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.serverList = res.ldata;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getAvailablePackage() {
      if (!this.taskId) {
        self.$message({
          type: "error",
          message: "请选择服务",
          center: true,
        });
      }
      let self = this;
      self.loading = true;
      this.$http
        .get("/publish/queryAvaliablePackage?taskId=" + this.taskId, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.availablePackageList = res.ldata;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    getServiceList() {
      let self = this;
      this.$http
        .get("/admin/release/task/list", {
          headers: { token: this.token },
        })
        .then(function(response) {
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.serviceList = res.ldata;
          let serviceListAll = JSON.parse(JSON.stringify(res.ldata));
          serviceListAll.unshift({
            id: "",
            label: "全部",
          });
          self.serviceListAll = serviceListAll;
        })
        .catch(function(response) {
          console.log(response);
        });
    },

    queryRecordList() {
      let params = {
        environment: this.env,
        taskId: this.taskId,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize,
      };
      let self = this;
      self.tableLoading = true;
      self.tableLoadingText = "数据获取中，请稍候...";
      this.$http
        .get(
          "/admin/release/task/instance/list?" + this.$qs.stringify(params),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.tableLoading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
          self.total = res.mdata.total;
        })
        .catch(function(response) {
          self.tableLoading = false;
        });
    },

    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/serviceInstanceList.vue